import React, { useState } from 'react';
import { X, ChevronRight, Gift } from 'lucide-react';
import { MOCK_GIFTS } from '../utils/constants';

const History = ({ games, onClose }) => {
  const [selectedGame, setSelectedGame] = useState(null);

  const getGiftById = (id) => {
    return MOCK_GIFTS.find(g => g.id === id);
  };

  return (
    <>
      {/* History List */}
      <div 
        className="fixed inset-0 bg-black/50 flex items-end z-50"
        onClick={onClose}
      >
        <div 
          className="bg-gradient-to-b from-blue-800 to-purple-800 rounded-t-3xl w-full max-h-80vh overflow-y-auto p-6"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold">История игр</h3>
            <button 
              onClick={onClose}
              className="hover:bg-white/10 p-2 rounded-full transition"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {games.length === 0 ? (
            <div className="text-center py-8 text-gray-300">
              <p>История пуста</p>
            </div>
          ) : (
            <div className="space-y-3">
              {games.map(game => (
                <div 
                  key={game.gameId}
                  onClick={() => setSelectedGame(game)}
                  className="bg-blue-700/50 backdrop-blur-sm p-4 rounded-xl cursor-pointer hover:bg-blue-600/50 transition"
                >
                  <div className="flex justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                        👤
                      </div>
                      <span className="font-medium">@{game.winner || 'Unknown'}</span>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center gap-1 text-yellow-400 font-bold">
                        <Gift className="w-4 h-4" />
                        {game.winAmount?.toFixed(2)}
                      </div>
                      <div className="text-sm text-gray-300">
                        {game.participants?.[game.winner]?.percentage?.toFixed(2)}%
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-end">
                    <div>
                      <div className="flex gap-1 mb-1">
                        {Object.values(game.participants || {}).slice(0, 3).map((p, i) => {
                          const gift = getGiftById(p.giftId);
                          return gift ? (
                            <span key={i} className="text-2xl">{gift.icon}</span>
                          ) : null;
                        })}
                      </div>
                      <div className="text-xs text-gray-300">
                        Игра #{game.gameNumber} • {game.date}
                      </div>
                    </div>
                    <ChevronRight className="w-5 h-5 text-gray-400" />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Game Details Modal - ВЫШЕ истории (z-index больше) */}
      {selectedGame && (
        <div 
          className="fixed inset-0 bg-black/70 flex items-center justify-center p-4"
          style={{ zIndex: 100 }}
          onClick={() => setSelectedGame(null)}
        >
          <div 
            className="bg-gradient-to-b from-blue-800 to-purple-800 rounded-2xl w-full max-w-md p-6 max-h-90vh overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex justify-between mb-4">
              <div className="flex items-center gap-2">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-xl">
                  👤
                </div>
                <span className="font-bold">@{selectedGame.winner}</span>
              </div>
              <div className="text-right">
                <div className="flex items-center gap-1 text-yellow-400 font-bold text-xl">
                  <Gift className="w-5 h-5" />
                  {selectedGame.winAmount?.toFixed(2)}
                </div>
                <div className="text-sm text-gray-300">
                  {selectedGame.participants?.[selectedGame.winner]?.percentage?.toFixed(2)}%
                </div>
              </div>
            </div>

            <div className="bg-blue-700/30 rounded-xl p-4 mb-4">
              <h4 className="font-medium mb-3">Участники и подарки:</h4>
              <div className="space-y-2">
                {Object.entries(selectedGame.participants || {}).map(([userId, p]) => {
                  const gift = getGiftById(p.giftId);
                  return gift ? (
                    <div key={userId} className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-2xl">{gift.icon}</span>
                        <div>
                          <div className="text-sm">{gift.name}</div>
                          <div className="text-xs text-gray-400">@{userId}</div>
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="flex items-center gap-1 text-yellow-400">
                          <Gift className="w-4 h-4" />
                          <span>{gift.price.toFixed(2)}</span>
                        </div>
                        <div className="text-xs text-gray-300">
                          ({gift.price.toFixed(2)} TON)
                        </div>
                      </div>
                    </div>
                  ) : null;
                })}
              </div>
            </div>

            <div className="text-sm text-gray-300 mb-4 space-y-1">
              <div>Билет: #{selectedGame.winningTicket}</div>
              <div>Игра #{selectedGame.gameNumber}</div>
              <div>{selectedGame.date}</div>
            </div>

            <button 
              onClick={() => setSelectedGame(null)}
              className="w-full bg-gradient-to-r from-yellow-500 to-orange-500 py-3 rounded-lg font-medium hover:from-yellow-600 hover:to-orange-600 transition"
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default History;